import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import i18n from '../i18n'
import { getLanguageFromURL, updateURLLanguage } from '../utils/language'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue'),
    },
    {
      path: '/rewrite',
      name: 'Rewrite',
      component: () => import('../views/Rewrite.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/history',
      name: 'History',
      component: () => import('../views/History.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: () => import('../views/Pricing.vue'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
      meta: { guestOnly: true },
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('../views/Register.vue'),
      meta: { guestOnly: true },
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('../views/Settings.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/success',
      name: 'Success',
      component: () => import('../views/PaymentSuccess.vue'),
    },
    {
      path: '/payment/success',
      name: 'PaymentSuccess',
      component: () => import('../views/PaymentSuccess.vue'),
    },
    {
      path: '/api-docs',
      name: 'ApiDocs',
      component: () => import('../views/ApiDocs.vue'),
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: () => import('../views/PrivacyPolicy.vue'),
    },
    {
      path: '/terms',
      name: 'TermsOfService',
      component: () => import('../views/TermsOfService.vue'),
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('../views/Contact.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../views/NotFound.vue'),
    },
  ],
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  // 检查 URL 语言参数
  const urlLang = getLanguageFromURL()
  if (urlLang && urlLang !== i18n.global.locale.value) {
    i18n.global.locale.value = urlLang
    localStorage.setItem('preferred-language', urlLang)
    document.querySelector('html')?.setAttribute('lang', urlLang)
  }
  
  // 需要登录的页面
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }
  
  // 仅游客可访问的页面
  if (to.meta.guestOnly && authStore.isAuthenticated) {
    next({ name: 'Home' })
    return
  }
  
  next()
})

export default router
